module.exports = {"URL":"https://hapiickapi.azure-api.net/admin-real","SUBSCRIPTION":"76bc21ed068f4c2bb292720bf1ffdce1"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1